<template>
  <div class="lot-data">
    <div class="row">
      <div class="col-lg-6 mb-6">
        <snow-input
          v-model="lot.name"
          label="Nome do ingresso *"
          :rules="rules.name"
        />
      </div>
      <div class="col-lg-6 mb-5">
        <snow-input
          v-model="lot.stock"
          type="number"
          label="Quantidade de ingressos *"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4">
        <snow-input
          v-model="lot.price"
          label="Valor em Real Brasileiro (R$)"
          money
          class="mb-5"
          id="price"
          required
          :rules="rules.price"
        />
      </div>
      <div class="col-lg-4">
        <snow-input
          v-model="lot.price_usd"
          label="Valor em Dólar Americano (US$)"
          class="mb-5"
          id="price"
          money
          :moneyConfig="{ ...moneyConfig, prefix: 'US$ ' }"
          :rules="rules.foreignPricing"
        />
      </div>
      <div class="col-lg-4">
        <snow-input
          v-model="lot.price_eur"
          label="Valor em Euro (€)"
          class="mb-5"
          id="price"
          money
          :moneyConfig="{ ...moneyConfig, prefix: '€ ' }"
          :rules="rules.foreignPricing"
        />
      </div>
    </div>

    <h5 class="text-semibold mb-3 mt-2">Tipo de ingresso</h5>

    <div class="alert">
      <!-- <div v-if="!isEvent" class="alert"> -->
      <i class="ph ph-warning-circle fs-18 pb-1" />
      <div>
        <div class="fs-14">Atenção</div>
        <div class="text-dark-40 fs-12">
          Ingressos por lote deverão estar atrelados ao final da venda de um
          lote predefinido. Sendo assim, configure seu primeiro ingresso antes
          de selecionar essa opção.
        </div>
      </div>
    </div>

    <snow-radio
      v-model="lot.type"
      class="mb-3"
      :disabled="!parentOptions.length"
      :options="[
        { id: 'by_date', name: 'Por data' },
        {
          id: 'per_batch',
          name: 'Por lote',
          warning:
            'Ingressos por lote deverão estar atrelados ao final da venda de um lote predefinido. Sendo assim, configure seu primeiro ingresso antes de selecionar essa opção.'
        }
      ]"
    />

    <div class="row align-items-center">
      <div class="col-lg-6 mb-2 mb-lg-0 align-items-start">
        <snow-select
          v-if="lot.type == 'per_batch'"
          v-model="lot.parent_id"
          label="Início das vendas quando esse ingresso esgotar *"
          :options="parentOptions"
        />
        <snow-date-picker
          v-else
          v-model="lot.start_at"
          size="lg"
          format="YYYY-MM-DD HH:mm"
          isHours
        />
      </div>
      <div class="col-lg-6">
        <snow-date-picker
          v-model="lot.end_at"
          size="lg"
          format="YYYY-MM-DD HH:mm"
          isHours
        />
      </div>
    </div>
  </div>
</template>
<script>
import { moreOrEqualTo, required, maxLength } from "@/functions/validation.js";
export default {
  props: {
    lot: {
      type: Object,
      default: () => ({})
    },
    parentOptions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      moneyConfig: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        prefix: "",
        masked: false
      },
      rules: {
        name: [required(), maxLength(64)],
        price: [moreOrEqualTo(4)],
        foreignPricing: [
          val =>
            !!(!val || val >= 4) ||
            "Caso haja valor, deve ser maior ou igual a 4"
        ]
      }
    };
  },
  methods: {
    resetInputs() {
      Object.values(this.$refs).forEach(ref => ref.reset && ref.reset());
    }
  },
  watch: {
    parentOptions(v) {
      if (!v.length) this.lot.type = "by_date";
    }
  }
};
</script>

<style lang="scss" scoped>
.lot-data {
  .alert {
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    padding: 1rem;
    margin-block: 16px;
    border-radius: 1rem;
    background-color: white;
  }
}
</style>
